import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getPublicWifiAccounts,
  getPublicWifiAccountsPending,
  getPublicWifiAccountsSuccess,
  isUserMsisdnOwner,
} from '../../store/reducers';
import { OnDestroyHookDirective } from '../../shared/hooks';
import { PublicWifiAccount } from '../store/reducers/public-wifi.reducer';
import { PublicWifiAccountFilterPipe } from '../pipe/public-wifi-account-filter-pipe';

@Component({
  selector: 'mprd-public-wifi-accounts',
  templateUrl: './public-wifi-accounts.component.html',
  styleUrls: ['./public-wifi-accounts.component.css'],
})
export class PublicWifiAccountsComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  accounts: Array<PublicWifiAccount>;
  hasActiveAccount: boolean;
  isPending: boolean;
  isAccountLoadedSuccess: boolean;
  isOwner: boolean;

  constructor(
    private store: Store<ApplicationState>,
    private publicWifiAccountFilterPipe: PublicWifiAccountFilterPipe,
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.store.select(getPublicWifiAccounts).subscribe((accounts) => {
        this.accounts = accounts;
        this.hasActiveAccount =
          this.publicWifiAccountFilterPipe.transform(accounts, true).length > 0;
      }),
    );

    this.addSubscription(
      this.store.select(getPublicWifiAccountsPending).subscribe((value) => {
        this.isPending = value;
      }),
    );

    this.addSubscription(
      this.store.select(getPublicWifiAccountsSuccess).subscribe((value) => {
        this.isAccountLoadedSuccess = value;
      }),
    );

    this.addSubscription(
      this.store.select(isUserMsisdnOwner).subscribe((value) => {
        this.isOwner = value;
      }),
    );
  }
}
